import { Box, Checkbox, FormControlLabel, SxProps, Theme, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { dayjs } from "../../../utils/dayjs";
import { useI18n } from "../../hooks/useI18n";
import { useVaccineWithDiseases } from "../../hooks/useVaccineWithDiseases";
import { StyledCheckbox } from "../mui/StyledCheckbox";

export const BoosterForm = ({
  birthDate,
  vaccinationDate,
  sx,
  vaccineId,
  booster,
  onBoosterChange,
  isReadonly = false,
}: {
  birthDate: Date | undefined;
  vaccinationDate: Date | undefined;
  vaccineId: string;
  booster: boolean;
  onBoosterChange?: (booster: boolean) => void;
  isReadonly?: boolean;
  sx?: SxProps<Theme> | undefined;
}) => {
  const { t } = useI18n();
  const [isVisible, setIsVisible] = useState(booster);
  const vaccineWithDiseases = useVaccineWithDiseases(vaccineId);

  useEffect(() => {
    if (vaccinationDate && vaccineWithDiseases && birthDate && vaccineId !== "") {
      //Display booster if age is more or equal than 5
      const isMoreOrEqualFive = vaccinationDate && dayjs(dayjs(vaccinationDate)).diff(birthDate, "year") >= 5;
      //And if disease equal to Diphteria or Tetanos or Polio
      const specificDiseases = ["Diphtérie", "Tétanos", "Poliomyélite"];
      const isDiphteriaOrTetanosOrPolio = vaccineWithDiseases?.diseases.some((disease) =>
        specificDiseases.includes(disease.name["fr"] as string),
      );
      setIsVisible(isMoreOrEqualFive && isDiphteriaOrTetanosOrPolio);
    } else {
      setIsVisible(false);
      onBoosterChange?.(false);
    }
  }, [vaccineWithDiseases, vaccinationDate, birthDate, onBoosterChange, vaccineId]);

  const handleBoosterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    onBoosterChange?.(newValue);
  };

  return isVisible ? (
    <Box sx={{ mt: 0.5, ...sx }}>
      <StyledCheckbox fullWidth disabled={isReadonly} testId="booster">
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleBoosterChange}
              checked={booster}
              name="booster"
              value="yes"
              size="small"
              data-testid="boosterCheckbox"
            />
          }
          label={<Typography variant="body2">{t("vaccines.booster")}</Typography>}
        />
      </StyledCheckbox>
    </Box>
  ) : null;
};
